import React from 'react'
import styled, { css } from 'styled-components'

export interface LoadingSvgPropsType {
	size?: number | string
	[key: string]: any
}

export const LoadingSvg: React.FC<LoadingSvgPropsType> = ({
	size = 30,
	...p
}) => {
	return (
		<Body {...p}>
			<svg
				className="loading-svg-container"
				height={size}
				width={size}
				viewBox="0 0 100 100"
			>
				<Bg className="loading-svg-bg" cx="50" cy="50" r="45" />
				<Arc className="loading-svg-animate" cx="50" cy="50" r="45" />
			</svg>
		</Body>
	)
}

const Body = styled.div`
	display: flex;
	position: relative;
	align-content: space-around;
	justify-content: center;
`

const CircleCss = css`
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	fill: none;
	stroke-width: 5px;
	stroke-linecap: round;
`

const Bg = styled.circle`
	${CircleCss};
	stroke-width: 8px;
	stroke: transparent;
`

const Arc = styled.circle`
	${CircleCss};
	stroke-dasharray: 242.6;
	animation: fill-animation 1s cubic-bezier(1, 1, 1, 1) 0s infinite;
	/* primary/08 */
	stroke: #4096fb;

	@keyframes fill-animation {
		0% {
			stroke-dasharray: 40 242.6;
			stroke-dashoffset: 0;
		}
		50% {
			stroke-dasharray: 141.3;
			stroke-dashoffset: 141.3;
		}
		100% {
			stroke-dasharray: 40 242.6;
			stroke-dashoffset: 282.6;
		}
	}
`
